function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS PhoneNumbers INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import phones from "../../utils/phones";

/**
 * @visibleName PhoneNumbers DEPRECATED
*/

var PhoneNumbers = function PhoneNumbers(_ref) {
  var _ref$phone_numbers = _ref.phone_numbers,
    phone_numbers = _ref$phone_numbers === void 0 ? [] : _ref$phone_numbers,
    hideLabels = _ref.hideLabels,
    isInNetworkGroup = _ref.isInNetworkGroup,
    sortOrder = _ref.sortOrder,
    detailedExtension = _ref.detailedExtension;
  var phoneNumbers = phones.sortPhoneNumbers(phone_numbers, sortOrder);
  return phoneNumbers.map(function (phoneNumber) {
    var _phoneNumber$extensio = phoneNumber.extension,
      extension = _phoneNumber$extensio === void 0 ? '' : _phoneNumber$extensio,
      _phoneNumber$phone_ty = phoneNumber.phone_type,
      phone_type = _phoneNumber$phone_ty === void 0 ? '' : _phoneNumber$phone_ty,
      _phoneNumber$phone_nu = phoneNumber.phone_number,
      phone_number = _phoneNumber$phone_nu === void 0 ? '' : _phoneNumber$phone_nu;
    var capitalized_phone_type = phone_type ? phone_type[0].toUpperCase() + phone_type.slice(1) : '';
    var numberText = !hideLabels && capitalized_phone_type ? "".concat(capitalized_phone_type, ": ") : '';
    numberText += phones.formatPhoneNumber(extension ? phone_number + extension : phone_number, detailedExtension);
    return /*#__PURE__*/React.createElement("div", {
      key: "phone-".concat(phone_number),
      className: "ui-contact-information__phone mb-half"
    }, /*#__PURE__*/React.createElement("a", {
      href: phones.getTelLink(phoneNumber, detailedExtension),
      target: "_blank",
      tabIndex: 0,
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "program-details__icon program-details__icon--phone mr-quarter",
      color: "".concat(isInNetworkGroup ? '#4571BA' : '#2C405A'),
      icon: "V2Phone"
    }), /*#__PURE__*/React.createElement("span", _extends({
      className: "ui-provider-card__icon-text--phone ml-half normal-case"
    }, detailedExtension && {
      'data-test-element': 'client_phone_number'
    }), numberText)));
  });
};
PhoneNumbers.propTypes = {
  hideLabels: PropTypes.bool,
  isInNetworkGroup: PropTypes.bool,
  phone_numbers: PropTypes.array.isRequired,
  sortOrder: PropTypes.array,
  detailedExtension: PropTypes.bool
};
PhoneNumbers.defaultProps = {
  hideLabels: false,
  isInNetworkGroup: true,
  sortOrder: ['work', 'mobile', 'home', 'phone', 'fax', 'other', 'unknown'],
  detailedExtension: false
};
export default PhoneNumbers;